import { Suspense } from "react";
import ReactDOM from "react-dom/client";
import { Route, Routes, Router, useNavigate } from "./router.js";
import { StyledEngineProvider, ThemeProvider } from "@mui/material/styles";
import * as Sentry from "@sentry/browser";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { ErrorBoundary } from "react-error-boundary";
import { CssBaseline } from "@mui/material";

import "./index.scss";
import logo from "./assets/images/logoNew.png";
import "react-table-6/react-table.css";
import SnackBar from "./components/Snackbar.js";
import NotFound from "./screens/NotFound.js";
import ChoosePlan from "./screens/ChoosePlan.jsx";
import SoloPlan from "./screens/SoloPlan.jsx";
import TeamPlan from "./screens/TeamPlan.jsx";
import ServicesPlan from "./screens/ServicesPlan.jsx";
import Checkout from "./screens/Checkout.jsx";
import CheckoutResult from "./screens/CheckoutResult.jsx";
import theme from "./theme.js";

import "./i18n.js";
import { SuspenseSpinner, ErrorFallback, Header } from "#components";

const {
	NODE_ENV,
	REACT_APP_SENTRY_DSN,
	REACT_APP_SENTRY_ENVIRONMENT,
} = process.env;

Sentry.init({
	dsn: REACT_APP_SENTRY_DSN,
	environment: REACT_APP_SENTRY_ENVIRONMENT,
	ignoreErrors: [
		"ResizeObserver loop limit exceeded",
		"Non-Error promise rejection captured",
	],
	enabled: NODE_ENV === "production",
});

const App = () => {
	const navigate = useNavigate();
	return (
		<StyledEngineProvider injectFirst>
			<CssBaseline />
			<ThemeProvider theme={theme}>
				<ErrorBoundary FallbackComponent={ErrorFallback}>
					<LocalizationProvider dateAdapter={AdapterDayjs}>
						<Header logo={logo} navigate={navigate}/>
						<main style={{ position: "relative", zIndex: 0, height: "calc(100vh - 74px)" }}>
							<Routes>
								<Route index element={<ChoosePlan />} />
								<Route path="home" element={<ChoosePlan />} />
								<Route path="solo-plan" element={<SoloPlan />} />
								<Route path="team-plan" element={<TeamPlan />} />
								<Route path="services" element={<ServicesPlan />} />
								<Route path="checkout" element={<Checkout />} />
								<Route path="checkout-success" element={<CheckoutResult result="success" />} />
								<Route path="checkout-failure" element={<CheckoutResult result="failure" />} />
								<Route path="*" element={<NotFound />} />
							</Routes>
						</main>
						<SnackBar />
					</LocalizationProvider>
				</ErrorBoundary>
			</ThemeProvider>
		</StyledEngineProvider>
	);
};

const root = ReactDOM.createRoot(document.querySelector("#root"));
root.render(
	<Suspense fallback={<SuspenseSpinner />}>
		<Router>
			<App />
		</Router>
	</Suspense>
);
